// mocked globally in setupTests.js

import { RESET_BUTTON_WIDTH_IN_PX } from '../components/buttons/ResetFieldButton';
import Constants from './Constants';

export const getCanvasContext = () => document.createElement('canvas').getContext('2d');

export const getTextWidth = (context, font, text) => {
    context.font = font;
    const metrics = context.measureText(text);
    return Math.ceil(metrics.width);
};

export const getInputMaxWidth = (node) => {
    const fieldComputedStyle = window.getComputedStyle(node.closest('.field'));
    const fieldPadding = parseInt(fieldComputedStyle.paddingLeft, 10) + parseInt(fieldComputedStyle.paddingRight, 10);
    const fieldMargin = parseInt(fieldComputedStyle.marginLeft, 10) + parseInt(fieldComputedStyle.marginRight, 10);
    return node.closest('.field-container').parentElement.clientWidth
        - fieldPadding
        - fieldMargin
        - Constants.DYNAMIC_WIDTH_GAP_IN_PX
        - RESET_BUTTON_WIDTH_IN_PX;
};

export const getTextFont = (node) => {
    const computedStyle = window.getComputedStyle(node);
    return `${computedStyle.fontWeight} ${computedStyle.fontSize} ${computedStyle.fontFamily}`;
};
